"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSuspense = exports.Suspense = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const UI_1 = require("../UI");
const Suspense = (props) => {
    let fallback;
    if (props.fallback !== undefined) {
        fallback = props.fallback;
    }
    else {
        const { loader } = UI_1.useUIContext().useLoader({ loading: true });
        fallback = loader;
    }
    return jsx_runtime_1.jsx(react_1.Suspense, Object.assign({ fallback: fallback || null }, props), void 0);
};
exports.Suspense = Suspense;
const withSuspense = (component) => {
    return jsx_runtime_1.jsx(exports.Suspense, { children: component }, void 0);
};
exports.withSuspense = withSuspense;
//# sourceMappingURL=Suspense.js.map